import { Component, effect, inject, input, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Tab, TabList, Tabs } from 'primeng/tabs';
import { Chip } from 'primeng/chip';
import { ClientsClient, PackageUserData } from '../../../infrastructure/shared/model/fss.api';
import { LocationAdminService } from '../../../infrastructure/shared/services/location-admin.service';
import { Arrow } from '../../../infrastructure/shared/icons/arrow/arrow';
import { Building05 } from '../../../infrastructure/shared/icons/building-05/building-05';
import { UserCircle } from '../../../infrastructure/shared/icons/user-circle/user-circle';
import { Mail02 } from '../../../infrastructure/shared/icons/mail-02/mail-02';
import { Phone } from '../../../infrastructure/shared/icons/phone/phone';
import { Cube01 } from '../../../infrastructure/shared/icons/cube-01/cube-01';
import { Calendar } from '../../../infrastructure/shared/icons/calendar/calendar';
import { InfoCircle } from '../../../infrastructure/shared/icons/info-circle/info-circle';
import { AdminClientPackagesTab } from '../admin-client-packages-tab/admin-client-packages-tab';
import { AdminClientTerminiTab } from '../admin-client-termini-tab/admin-client-termini-tab';
import { AdminClientAboutTab } from '../admin-client-about-tab/admin-client-about-tab';
import { AdminClientIndividualPackageTab } from '../admin-client-individual-package-tab/admin-client-individual-package-tab';

@Component({
  standalone: true,
  selector: 'app-admin-client-details',
  imports: [
    Tab,
    TabList,
    Tabs,
    Chip,
    Arrow,
    Building05,
    UserCircle,
    Mail02,
    Phone,
    Cube01,
    Calendar,
    InfoCircle,
    AdminClientPackagesTab,
    AdminClientTerminiTab,
    AdminClientAboutTab,
    AdminClientIndividualPackageTab,
  ],
  templateUrl: './admin-client-details.html',
  styleUrl: './admin-client-details.scss',
})
export class AdminClientDetails {
  private _client = inject(ClientsClient);
  private _location = inject(LocationAdminService);

  id = input<string>();
  data = signal<PackageUserData | undefined>(undefined);
  activeTab = signal<number>(0);

  constructor() {
    effect(() => {
      const clientId = this.id();
      if (clientId) {
        this._load(clientId);
      }
    });
  }

  routeToClients() {
    this._location.routeToClients();
  }

  onTabChange(value: any) {
    this.activeTab.set(Number(value ?? 0));
  }

  private _load(id: string) {
    this._getData(id).then((res) => {
      this.data.set(res.result);
    });
  }

  private async _getData(id: string) {
    return await firstValueFrom(this._client.getClient(id));
  }
}
